import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { TeamFieldConfig } from "./entity";

const createCustomFilter = createCustomFilterForEntity<TeamFieldConfig>();

export class TeamFieldConfigFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<TeamFieldConfig>
  >((filters) => {
    return filterWithRelationsAndJson(TeamFieldConfig)(filters);
  });
}
